<template>
    <div class="detail" :class="role === '2' ? 'details' : ''">
        <div class="detail-header">
            <el-breadcrumb separator=">" class="customBreadcrumb">
                <el-breadcrumb-item>你当前所在位置</el-breadcrumb-item>
                <el-breadcrumb-item>数据中心</el-breadcrumb-item>
                <el-breadcrumb-item>班级数据</el-breadcrumb-item>
                <el-breadcrumb-item>{{classData.class_name}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" @click="goBack">返回</el-button>
        </div>
        <div class="title">
            <i class="iconfont">&#xe70e;</i>
            <span class="text">{{classData.class_name}}</span>
        </div>
        <div class="data-item">
            <div class="class-item">
                <div class="class-table">
                    <div class="table-title">
                        <span class="title-item">学生名称</span>
                        <span class="title-item">训练次数</span>
                        <span class="title-item">模拟次数</span>
                        <span class="title-item">考试次数</span>
                        <span class="title-item">1+X电子商务客服证书</span>
                    </div>
                    <el-scrollbar class="table-body">
                        <div class="body-item" v-for="itemStudent in classData.list">
                            <div class="student-name title-item">
                                <img :src="itemStudent.avatar ? itemStudent.avatar : require('../../../assets/images/user_img.png')" alt="">
                                <span class="name">{{itemStudent.nickname}}</span>
                            </div>
                            <span class="text title-item">{{itemStudent.train_num}}</span>
                            <span class="text title-item">{{itemStudent.simulate_num}}</span>
                            <span class="text title-item">{{itemStudent.official_num}}</span>
                            <i class="iconfont title-item pass-i" v-if="itemStudent.has_certificate === 1">&#xe656;</i>
                            <i class="iconfont title-item no-pass-i" v-else>&#xe659;</i>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { infocenterteacherCenterClassList, infocenterschoolCenterClassList } from '@/utils/apis.js'

    export default {
        name: "Detail",
        data() {
            return {
                role: '',
                //班级数据
                classData: {}
            }
        },
        created() {
            this.role = localStorage.getItem('role');
            this.getClassData();
        },
        methods: {
            //获取班级数据
            getClassData() {
                let param = {
                    class_id: this.$route.query.c_id
                }
                let url = '';
                if (this.role === '2') {
                    url = infocenterschoolCenterClassList;

                } else {
                    url = infocenterteacherCenterClassList;
                }
                url(param).then((res) => {
                    this.classData = res.data;
                }).catch((err) => {
                    console.log(err);
                });
            },
            //返回
            goBack() {
                this.$router.go(-1)
            }
        }
    }
</script>

<style scoped lang="scss">
    .details {
        .detail-header {
            margin-top: 20px;
        }
    }
    .detail {
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        top: -20px;
        bottom: 0;
        width: 100%;
        height: calc(100% + 20px);
        position: relative;
        background: #F7F8FC;
        .detail-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .customBreadcrumb {
                ::v-deep .el-breadcrumb__item:nth-child(1) .el-breadcrumb__inner {
                    color: #333333;
                    font-size: 14px;
                }
                ::v-deep .el-breadcrumb__item:nth-child(2) .el-breadcrumb__inner {
                    color: #2C95FF;
                    font-size: 14px;
                }
                ::v-deep .el-breadcrumb__item:nth-child(3) .el-breadcrumb__inner {
                    color: #2C95FF;
                    font-size: 14px;
                }
                ::v-deep .el-breadcrumb__item:nth-child(4) .el-breadcrumb__inner {
                    color: #2C95FF;
                    font-size: 14px;
                }
            }
        }
        .title {
            position: relative;
            height: 50px;
            margin-top: 35px;
            line-height: 50px;

            i {
                color: #F23B2F;
                font-size: 30px;
                margin-right: 10px;
            }
            .text {
                position: absolute;
                display: inline-block;
                width: 218px;
                height: 50px;
                line-height: 50px;
                font-size: 20px;
                color: #333;
                font-weight: 500;
            }
        }
        .data-item {
            flex: 1;
            height: 1%;
        }
        .class-item {
            display: flex;
            flex-direction: column;
            background: #FFFFFF;
            height: calc(100% - 20px);
            box-shadow: 0 0 10px 0 rgba(14, 168, 94, 0.1);
            border-radius: 6px;
            margin-top: 20px;
            padding: 40px 0 20px 20px;
            box-sizing: border-box;
            .class-top {
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #2DC079;
            }
            .class-table {
                display: flex;
                flex-direction: column;
                flex: 1;
                height: 1%;
                margin-top: 10px;
                .table-title {
                    height: 51px;
                    line-height: 51px;
                    background: #F6F6F6;
                    padding: 0 70px;
                    margin-right: 30px;
                }
                .title-item {
                    display: inline-block;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #333;
                    text-align: center;
                    width: 15%;
                    &:nth-child(1) {
                        width: 40%;
                        text-align: left;
                    }
                }
                .table-body {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    height: 1%;
                    ::v-deep > .el-scrollbar__wrap {
                        overflow-x: hidden;
                    }
                    ::v-deep > .el-scrollbar__bar.is-vertical {
                        width: 10px;
                        .el-scrollbar__thumb {
                            background-color: #F23B2F;
                        }
                    }
                    .body-item {
                        display: flex;
                        align-items: center;
                        height: 90px;
                        padding: 0 100px;
                        border-bottom: 1px solid #EEEEEE;
                        .title-item {
                            color: #333;
                            font-weight: 400;
                        }
                        .pass-i {
                            color: #2DC079;
                            font-size: 30px;
                        }
                        .no-pass-i {
                            color: #FF0000;
                            font-size: 30px;
                        }
                        .student-name {
                            display: flex;
                            align-items: center;
                            img {
                                width: 42px;
                                height: 42px;
                                border-radius: 50%;
                                margin-right: 20px;
                            }
                        }
                    }
                }
            }
            .more {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #2DC079;
                margin-top: 27px;
                cursor: pointer;
                i {
                    font-size: 20px;
                }
            }
        }
    }
</style>